import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
// import 'src/styles/components/_appNavBar.scss';
import 'src/styles/components/_subNavBar.scss';
import { Navbar, NavbarGroup } from '@blueprintjs/core';

const GISNavbar: React.FC = () => {
    type page = 'data-access' | 'portal';

    const dispatch = useDispatch();
    const [currentSection, setCurrentSection] = useState<page>(undefined);

    useEffect(() => {
        if (window.location.pathname.indexOf('/data-access') >= 0) {
            setCurrentSection('data-access');
        } else if (window.location.pathname.indexOf('/portal') >= 0) {
            setCurrentSection('portal');
        } else {
            setCurrentSection('portal');
        }
    }, [window.location.pathname]);

    const navigate = (path: string) => {
        console.log(currentSection);
        if (window.location.pathname.includes('gis/') && currentSection) {
            let newPath = path.replace('gis/', '');
            dispatch(push(newPath));
        } else {
            dispatch(push(path));
        }
    };

    const isActive = (section: string) => {
        if (section === currentSection) {
            return 'active';
        }
        return '';
    };

    return (
        <Navbar className="nav-bar">
            <NavbarGroup>
                {/* Portal first: it's where the GIS button lands. Data Access (plot tracking) is unused for now. */}
                <div className={'sub-nav-menu-item ' + isActive('portal')} onClick={() => navigate('gis/portal')}>
                    Portal
                </div>
                <div className={'sub-nav-menu-item ' + isActive('data-access')} onClick={() => navigate('gis/data-access')}>
                    Data Access
                </div>
            </NavbarGroup>
        </Navbar>
    );
};

export default GISNavbar;


// WEBPACK FOOTER //
// ./src/components/gis/GISNavbar.tsx